<template>
  <div class="Add-Signal-To-Favourites" :class="get_starModifyClass" @click="toToggleFavourites">
    <StarIcon />
  </div>
</template>

<script setup>
  import { Props } from './scripts/props';
  import { useStore } from 'vuex';
  import { computed } from 'vue';
  import { toggleFavourites } from '@shared/api/posts/toggleFavourites.js';
  //-------------------------------
  import StarIcon from '@svg/Star.vue';
  //-------------------------------
  const props = defineProps(Props());
  const store = useStore();
  //-------------------------------
  //Класс модификатор для иконки избранного
  const get_starModifyClass = computed(() => {
    return props.signal.reactions.bookmarked.is_mine ? 'Add-Signal-To-Favourites--active' : '';
  });
  //-------------------------------
  //Добавить в избранное
  const toToggleFavourites = async () => {
    const response = await toggleFavourites({
      object_id: props.signal.id, 
      content_type: props.signal.content_type
    });
    store.dispatch('OldSignals/updateFavourites', { status: response.create, id: props.signal.id });
  }
</script>

<style lang="scss">
  @import './styles/styles';
</style>